import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';

import Icon from '../../atoms/Icon';
import SimpleButton from '../../atoms/SimpleButton';
import BundleIcon from '../../../assets/images/bundle-icon.png';

import { beautifyPrice } from '../../../utils';


/**
 * A simple BundleSelector.
 */

const paymentStringsToFloat = arr => {
	var newArr = [], calcPrice;
	for (let i=0;i<arr.length;i++) {

		calcPrice = parseFloat(arr[i].price.replace(',','.'));
		newArr.push({
			"runtime": arr[i].runtime,
          	"price": calcPrice
		});
	}
	return newArr;
}


const bundlePrice = payments => {
	var lowest = -1, currlowest = 0, obj, runtime = false, calcPrice;
	if(payments.hasOwnProperty('mke')) {
		obj = sortBy(paymentStringsToFloat(payments.mke), 'price');
		runtime = true;
		currlowest = obj[0].price;
		if(lowest===-1 || lowest > currlowest) {
			lowest = currlowest;
		}
	}
	if(payments.hasOwnProperty('mk')) {
		obj = sortBy(paymentStringsToFloat(payments.mk), 'price');
		runtime = true;
		currlowest = obj[0].price;
		if(lowest===-1 || lowest > currlowest) {
			lowest = currlowest;
		}
	}
	if(payments.hasOwnProperty('sf')) {
		calcPrice = parseFloat(payments.sf.price.replace(',','.'));
		runtime = true;
		if(lowest===-1 || lowest > calcPrice) {
			lowest = calcPrice;
		}
	}
	if(!runtime) {
		for (let key in payments) {
			calcPrice = parseFloat(payments[key].replace(',','.'));
			if(lowest===-1 || lowest > calcPrice) {
				lowest = calcPrice;
			}
		}
	}
	return {price: lowest.toFixed(2).toString().split('.').join(',<sup>')+'</sup>', runtime: runtime};
};

const bundleDescription = desc => {
	// var arr = desc.replace("\r","").split("•").filter((v, i, a) => a.indexOf(v) === i);
	// if(arr.length>1) {
	// 	var list = '<ul>';
	// 	for (var i = 0; i < arr.length; i++) {
	// 		list += '<li>'+arr[i]+'</li>';
	// 	}
	// 	list += '</ul>';
	// 	return {__html:list};
	// }
	// return {__html:arr[0]};
	return {__html:desc.split("\r").join("<br>")}
}

class BundleSelector extends React.Component {
	componentDidMount() {
		if(this.props.isSingleChoice) {
			this.props.onClick(this.props.bundle);
		}
	}
    render () {
    	const price = bundlePrice(this.props.bundle.payments);
        return (
          <div className={`bundleselector${this.props.selected?" selected":""}`} onClick={() => this.props.onClick(this.props.bundle)}>
            <div className="header">
            	<Icon filename="selected_invert" color="white" />
              <h3>{this.props.bundle.deviceName}</h3>
              <img src={BundleIcon} className="bundleicon" alt="bundleicon" />
            </div>
            <div className="inner">
            	<div className="specs">
              		<h3>Paketinhalt:</h3>
              		<p dangerouslySetInnerHTML={bundleDescription(this.props.bundle.deviceDescription)}/>
              	</div>
				<div className="sponsoring">
					{this.props.bundle.sponsoring.active ?
						<div>
							<h6>Förderbetrag: <span dangerouslySetInnerHTML={{__html:beautifyPrice(this.props.bundle.sponsoring.supportPrice)}} /> €</h6>
							<h6>Eigenanteil: <span dangerouslySetInnerHTML={{__html:beautifyPrice(this.props.bundle.sponsoring.customerPrice)}} /> €</h6>
						</div>
					: null}
				</div>
              	<div className="payment">
					  
				  {price.runtime?"ab ":null} <span dangerouslySetInnerHTML={{__html:price.price}} /> € {price.runtime?<span className="runtime">monatlich</span>:null}
              	</div>
              	<div className="action">
              		<Icon filename="selected_invert" color="white" />
              		<SimpleButton children={`Paket ${this.props.selected?" ausgewählt ":"auswählen »"}`} onClick={() => this.props.onClick(this.props.bundle)} />
              	</div>
            </div>
          </div>
        );
    }

}

BundleSelector.propTypes = {
	/** Button label */
	bundle: PropTypes.object.isRequired,
	/** Gets called when the user clicks on the button */
	onClick: PropTypes.func,
	/** boolean */
	selected: PropTypes.bool
}

BundleSelector.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a BundleSelector Component!', event.target);
	},
	/* eslint-enable no-console */
	selected: false
	
}


export default BundleSelector;





// WEBPACK FOOTER //
// ./src/components/molecules/BundleSelector/BundleSelector.js